<script setup lang="ts">
import { GUARANTEES } from '../content/site-content';

/**
 * «Perché fidarsi»: le quattro promesse che reggono un'asta contesa.
 *
 * Sta su fondo navy perché è la sezione che chiude il discorso: chi arriva
 * qui ha già capito cosa fa il prodotto e sta valutando se affidargli la serata
 * in cui si spendono cinquecento crediti.
 */
</script>

<template>
  <section class="section trust">
    <div class="page">
      <div class="section__head trust__head">
        <span class="eyebrow trust__eyebrow">Perché fidarsi</span>
        <h2 class="section__title trust__title">Un’asta contesa non perdona gli imprevisti</h2>
        <p class="section__lead trust__lead">
          Rete lenta, doppio tocco, browser chiuso per sbaglio, server riavviato: sono le cose che
          succedono davvero, ed è su queste che il motore è costruito.
        </p>
      </div>

      <ul class="claims">
        <li v-for="guarantee in GUARANTEES" :key="guarantee.id" class="claim">
          <h3 class="claim__title">{{ guarantee.title }}</h3>
          <p class="claim__body">{{ guarantee.body }}</p>
        </li>
      </ul>
    </div>
  </section>
</template>

<style scoped>
.trust {
  background: var(--color-deep);
  color: var(--color-deep-text);
}

.trust__eyebrow {
  color: var(--brand-lime-light);
}

.trust__title {
  color: #ffffff;
}

.trust__lead {
  color: var(--color-deep-muted);
}

.claims {
  display: grid;
  gap: 1.25rem 2rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.claim {
  padding-left: 1rem;
  border-left: 2px solid var(--brand-lime);
}

.claim__title {
  color: #ffffff;
  font-size: 1.0625rem;
}

.claim__body {
  margin-top: 0.4rem;
  color: var(--color-deep-muted);
  font-size: 0.9375rem;
}

@media (min-width: 48rem) {
  .claims {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
